import type { RouteRecordRaw } from 'vue-router'

// Profile 模块子页（好友 / 档案 / 日记回放 / 周报）
export const profileRoutes: RouteRecordRaw[] = [
  {
    path: '/friend-list/friend-guide',
    name: 'friend-guide',
    component: () => import('@/pages/Profile/FriendList/FriendGuide/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/profile/friend-list',
    name: 'profile-friend-list',
    component: () => import('@/pages/Profile/FriendList/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/profile/create-profile',
    name: 'profile-create-profile',
    component: () => import('@/pages/Profile/CreateProfile/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/profile/daily-replay',
    name: 'profile-daily-replay',
    component: () => import('@/pages/Profile/DailyReplay/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/profile/weekly-reports',
    name: 'profile-weekly-reports',
    component: () => import('@/pages/Profile/WeeklyReports/index.vue'),
    meta: { backMode: 'allow' },
  },
]
